import VendorEnrollmentRequestView from './containers/VendorEnrollmentRequestView';
export default VendorEnrollmentRequestView;

export {uiDataVendorEnrollmentRequestView} from './reducers/VendorEnrollmentRequestView';
